"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_TREE_NODE = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_TREE_NODE = (0, gql_1.gql)(`
  query productTreeNode($nodeId: ID!) {
    productTreeNode(id: $nodeId) {
      ...ProductTreeNodeFragment
    }
  }
`);
